import { AmityAuthProvider, CommunityGroupsProvider } from "@/providers";

import { CommunityScreen } from "@/app/modules/Community";

export const Community = () => {
  return (
    <AmityAuthProvider>
      <CommunityGroupsProvider>
        <CommunityScreen />
      </CommunityGroupsProvider>
    </AmityAuthProvider>
  );
};
